import React from 'react';
import styled from 'styled-components';
import Login from "../components/Login.js";
import bg from '../assets/bubble-bg.png';

const LoginPage = (props) => {
    return (
        <LoginContainer>
            <Title>Are you my baby?</Title>
            <Login
                setLogin={props.setLogin}
                setLogout={props.setLogout}
                setFalse={props.setFalse}
                isSignedIn={props.isSignedIn}
                buttonLabel={props.buttonLabel}
            />
        </LoginContainer>
    );
}

export default LoginPage;

const LoginContainer = styled.div`
    margin: 32px auto 32px auto;
    height: 70vh;
    padding-top: 200px;
    text-align: center;
    background: url(${bg}) center center no-repeat #000;

    @media (max-width: 425px) {
        margin-top: -20px;
        padding-top: 280px;
        width: 100vw;
        height: 90vh;
  }
`

const Title = styled.h3`
    width: 100%;
    text-align: center;
    margin-bottom: 32px;
    font-family: 'Petit Formal Script', cursive;
    font-weight: 100;
    font-size: 32px;
`;